import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FooterComponent } from 'src/app/layouts/footer/footer.component';
import { AuthService } from 'src/app/services/auth.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styles: [],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FooterComponent, RouterLink]
})
export class LoginComponent implements OnInit {

  private readonly auth = inject(AuthService);
  private readonly _toastrService = inject(ToastrService);
  private readonly router = inject(Router);
  private readonly _loaderService: LoaderService = inject(LoaderService);
  public isLoading = this._loaderService.isLoading;

  showPassword = signal(false);
  /* reclutador
  291100Jofri
  admin
  Admin123456
candidato
Candido123456
  */

  public form = new FormGroup({
    userName: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  ngOnInit(): void {
    if (this.auth.isLoggedIn()) {
      this.auth.doLoginNavigate();
    }
  }

  login() {
    if (this.form.invalid) {
      return;
    }

    const formValues = this.form.getRawValue() as any;
    this.auth.login({
      ...formValues
    }).subscribe(
      {
        next: res => {
          if (res?.errors?.length > 0) {
            this._toastrService.error(res.errors[0]);
            return;
          }
          this.auth.doLoginNavigate();
        },
        error: (error: string[]) => {
          this._toastrService.error(error[0]);
        }
      })
  }

}
